<template>
  <WebPageForDownload v-if="!isWeChat()"/>
  <WeChatVisit v-if="isWeChat()"/>
  <div style="position: absolute;bottom: 10%; width:100%;text-align: center; ">
    <span class="download-span" style="color:#3e3e3eab" >FINDPOP Download</span>
  </div>
 
</template>

<script setup>
import WebPageForDownload from "./WebPageForDownload.vue";
import WeChatVisit from "./WeChatVisit.vue";
import { onMounted } from "vue";

onMounted(() => {

 if (
  navigator.userAgent.toLowerCase().indexOf("iphone") > -1 ||
  navigator.userAgent.toLowerCase().indexOf("ipad") > -1
) {
  window.location.href = "https://apps.apple.com/us/app/findpop/id1641064444"; //apple
}
});


function isWeChat() {

  var ua = navigator.userAgent.toLowerCase();
  return ua.includes('weixin')
  //return ua.match(/MicroMessenger/i) === "micromessenger";
}


</script>
